import React from 'react';
import MainPage from './main/MainPage';

function App() {
  return (
    <MainPage/>
  );
}

export default App;
